// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__YeO2K","inputWrap":"CustomTip_inputWrap__3N80R"};